module.exports = __webpack_public_path__ + "images/sepa.8a27ebedd2364d3212f748a964e28859.svg";